
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("f2jse", function(module, exports) {
const $af26222306bcd346$var$generateGalleryId = (gallerySelector, galleryLinkSelector, postfix = "I")=>{
    const galleries = document.querySelectorAll(gallerySelector);
    let galleryId = `gallery-${postfix}`;
    galleries.forEach((gallery)=>{
        const links = gallery.querySelectorAll(galleryLinkSelector);
        links.forEach((link)=>{
            link.setAttribute("data-fancybox", galleryId);
        });
        galleryId += postfix;
    });
};
$af26222306bcd346$var$generateGalleryId(".gallery", ".gallery-icon a");
$af26222306bcd346$var$generateGalleryId(".wp-block-gallery", ".blocks-gallery-item a, .wp-block-image a", "W");
$af26222306bcd346$var$generateGalleryId(".s-text-videos", ".s-text-videos__video", "stv");
$af26222306bcd346$var$generateGalleryId(".g-simple-gallery", ".i-simple-gallery", "sgs");
$af26222306bcd346$var$generateGalleryId(".g-gallery-grid", ".i-gallery-grid", "sgg");

});


//# sourceMappingURL=fancybox-gallery-id-generator.11da9be0.js.map
